import React from 'react';
import './GetHelpItem.scss';
const GetHelpItem = _ref => {
  let {
    title,
    description,
    icon,
    showArrow = false
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "GetHelpItem-Container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(icon, " GetHelpItem-Icon")
  }), /*#__PURE__*/React.createElement("div", {
    className: "GetHelpItem-Content"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "GetHelpItem-Title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "GetHelpItem-Description"
  }, description)), showArrow && /*#__PURE__*/React.createElement("span", {
    className: "icon-right-arrow-thin GetHelpItem-Arrow"
  }));
};
export default GetHelpItem;